(() => {
  const header = document.querySelector('[data-site-header]');
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchButton = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');

  const setExpanded = (button, panel, expanded) => {
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', String(expanded));
    panel.classList.toggle('is-open', expanded);
    panel.hidden = !expanded;
  };

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const willOpen = menuButton.getAttribute('aria-expanded') !== 'true';
      setExpanded(menuButton, mobileMenu, willOpen);
      if (willOpen) setExpanded(searchButton, searchPanel, false);
    });
  }

  if (searchButton && searchPanel) {
    searchButton.addEventListener('click', () => {
      const willOpen = searchButton.getAttribute('aria-expanded') !== 'true';
      setExpanded(searchButton, searchPanel, willOpen);
      if (willOpen) {
        setExpanded(menuButton, mobileMenu, false);
        requestAnimationFrame(() => searchPanel.querySelector('input')?.focus());
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setExpanded(menuButton, mobileMenu, false);
    setExpanded(searchButton, searchPanel, false);
  });

  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !form.matches('[data-ajax-cart="true"]')) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const toast = document.querySelector('[data-cart-toast]');

      try {
        if (submit) submit.disabled = true;
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item.');
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
        if (toast) {
          toast.textContent = 'Added to cart.';
          toast.hidden = false;
          window.setTimeout(() => { toast.hidden = true; }, 2800);
        }
      } catch (error) {
        if (toast) {
          toast.textContent = error.message;
          toast.hidden = false;
          window.setTimeout(() => { toast.hidden = true; }, 3500);
        }
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });
})();
